export default {
  email: 'jouanny.jerome@gmail.com',
  linkedinUrl: 'https://www.linkedin.com/in/jérôme-jouanny-react-freelance',
  malt: 'https://www.malt.fr/profile/jeromejouanny',
};
